import * as React from 'react'

import SvgIcon, { SvgIconProps } from '../../SvgIcon'

const TwintIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="100%" height="100%" viewBox="0 0 140 46" xmlns="http://www.w3.org/2000/svg">
    <title>twint-logo</title>
    <desc>Created with Sketch.</desc>
    <rect width="100%" height="100%" fill="#00000" />
    <defs>
      <radialGradient cx="22.45%" cy="8.76%" fx="22.45%" fy="8.76%" r="113.287%" id="a">
        <stop stop-color="#fc0" offset="0%" />
        <stop stop-color="#FFC800" offset="9.157%" />
        <stop stop-color="#FFBD00" offset="17.39%" />
        <stop stop-color="#FFAB00" offset="25.28%" />
        <stop stop-color="#FF9100" offset="32.95%" />
        <stop stop-color="#FF7000" offset="40.46%" />
        <stop stop-color="#FF4700" offset="47.86%" />
        <stop stop-color="#FF1800" offset="55.03%" />
        <stop stop-color="#f00" offset="58.22%" />
        <stop stop-color="#f00" offset="100%" />
      </radialGradient>
      <radialGradient cx="2.431%" cy="14.525%" fx="2.431%" fy="14.525%" r="139.175%" id="b">
        <stop stop-color="#00B4E6" offset="0%" />
        <stop stop-color="#00B0E3" offset="20.1%" />
        <stop stop-color="#01A5DB" offset="38.98%" />
        <stop stop-color="#0292CD" offset="57.37%" />
        <stop stop-color="#0377BA" offset="75.46%" />
        <stop stop-color="#0455A1" offset="93.16%" />
        <stop stop-color="#054696" offset="100%" />
      </radialGradient>
    </defs>
    <g fill="none">
      <path
        d="M39.902 33.438c0 .59-.418 1.304-.933 1.599l-18.028 10.428c-.516.295-1.351.295-1.867 0l-18.028-10.428c-.516-.295-.933-1.008-.933-1.599v-20.856c0-.59.418-1.304.933-1.599l18.028-10.428c.516-.295 1.351-.295 1.867 0l18.028 10.428c.516.295.933 1.008.933 1.599v20.856zM139.989 14.082h-16.137v3.861h5.796v16.503h4.568v-16.503h5.772zM66.674 14.082h-16.161v3.861h5.796v16.503h4.568v-16.503h5.796zM113.389 13.443c-5.084 0-7.909 3.246-7.909 7.944v13.06h4.519v-13.158c0-2.041 1.204-3.615 3.439-3.615 2.235 0 3.414 1.869 3.414 3.615v13.158h4.519v-13.06c.025-4.698-2.898-7.944-7.982-7.944zM96.344 14.082v20.364h4.519v-20.364zM81.018 22.149l.147.91 4.249 11.387h1.842l5.772-20.364h-4.446l-2.751 10.699-.172 1.156-.221-1.156-3.684-10.699h-1.474l-3.684 10.699-.221 1.156-.147-1.156-2.751-10.699h-4.47l5.772 20.364h1.842l4.249-11.387.147-.91"
        id="Shape1"
        fill="#fff"
      />
      <path
        d="M29.414 23.059l-4.716 6.911-2.407-3.689 2.775-4.156c.516-.738 1.621-2.779.344-5.558-1.032-2.263-3.267-3.345-5.232-3.345-1.965 0-4.102 1.008-5.256 3.345-1.302 2.681-.172 4.771.319 5.485 0 0 1.547 2.263 2.825 4.181l2.088 3.025 3.144 4.821c.025.025.516.787 1.4.787.835 0 1.351-.762 1.425-.836l7.368-10.92h-4.077v-.049zm-9.26.172s-1.228-1.869-2.039-3.173c-.86-1.402.098-3.492 2.039-3.492 1.94 0 2.898 2.091 2.039 3.492-.786 1.304-2.039 3.173-2.039 3.173z"
        id="Shape2"
        fill="url(#a)"
      />
      <path
        d="M15.635 29.749l-4.618-6.493s-1.228-1.869-2.039-3.173c-.86-1.402.098-3.492 2.039-3.492.246 0 .467.025.688.098l1.621-2.976c-.737-.32-1.547-.492-2.284-.492-1.965 0-4.102 1.008-5.256 3.345-1.302 2.681-.172 4.771.319 5.485l8.081 11.978c.074.098.589.861 1.449.861.86 0 1.351-.738 1.425-.836l2.432-3.714-2.088-3.074-1.768 2.484z"
        fill="url(#b)"
      />
    </g>
  </SvgIcon>
)

export default TwintIcon
